import { Component, inject } from '@angular/core';
import { EnquireService } from '../../services/enquire.service';
import { BrochureService } from '../../services/brochure.service';

@Component({
  selector: 'app-hero',
  standalone: true,
  templateUrl: './hero.html',
  styleUrl: './hero.css'
})
export class HeroComponent {
  private enquireService = inject(EnquireService);
  private brochureService = inject(BrochureService);

  openEnquire() { this.enquireService.open(); }
  openBrochure() { this.brochureService.open(); }
}
